import createIcon from '../../createIcon';

/**
 * @component @name PhotoSizeSelectLarge
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTVIMjNWMTdIMjFWMTVaTTIxIDExSDIzVjEzSDIxVjExWk0yMyAxOUgyMVYyMUMyMiAyMSAyMyAyMCAyMyAxOVpNMTMgM0gxNVY1SDEzVjNaTTIxIDdIMjNWOUgyMVY3Wk0yMSAzVjVIMjNDMjMgNCAyMiAzIDIxIDNaTTEgN0gzVjlIMVY3Wk0xNyAzSDE5VjVIMTdWM1pNMTcgMTlIMTlWMjFIMTdWMTlaTTMgM0MyIDMgMSA0IDEgNUgzVjNaTTkgM0gxMVY1SDlWM1pNNSAzSDdWNUg1VjNaTTEgMTFWMTlDMSAyMC4xIDEuOSAyMSAzIDIxSDE1VjExSDFaTTMgMTlMNS41IDE1Ljc5TDcuMjkgMTcuOTRMOS43OSAxNC43MkwxMyAxOUgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoSizeSelectLarge = createIcon('PhotoSizeSelectLarge', [
  [
    'path',
    {
      d: 'M21 15H23V17H21V15ZM21 11H23V13H21V11ZM23 19H21V21C22 21 23 20 23 19ZM13 3H15V5H13V3ZM21 7H23V9H21V7ZM21 3V5H23C23 4 22 3 21 3ZM1 7H3V9H1V7ZM17 3H19V5H17V3ZM17 19H19V21H17V19ZM3 3C2 3 1 4 1 5H3V3ZM9 3H11V5H9V3ZM5 3H7V5H5V3ZM1 11V19C1 20.1 1.9 21 3 21H15V11H1ZM3 19L5.5 15.79L7.29 17.94L9.79 14.72L13 19H3Z',
      key: 'hpo5p7',
    },
  ],
]);

export default PhotoSizeSelectLarge;
